import React, { Component } from 'react';

import $ from 'jquery';
import { Animated } from 'react-animated-css';

//  ----------------   Form components
import Form from 'react-validation/build/form';
import Button from 'react-validation/build/button';

//  ----------------   Custom Form components & validations rules
import { OtpField, required, numOnly, minChar6, lt } from '../formValidation';

class OTPForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      otp: null,
      loading: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    // input field animation code - adds class to current focused input field's parent
    if (value) {
      target.parentElement.classList.add('input--filled');
    } else {
      target.parentElement.classList.remove('input--filled');
    }

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    // get data from all fields in form
    const data = this.form.getValues();

    const url = ''; // url for otp verification

    // api call to verify OTP
    $.ajax({
      url: url,
      dataType: 'json',
      type: 'POST',
      data: data,
      success: function (res) {
   
        this.props.history.push('/dashboard');
      }.bind(this),
      error: function (xhr, status, err) {
        console.error(url, status, err.toString());
      }.bind(this)
    });
  }

  render() {
    return (
      <div>
        <Animated className="form-animation" animationIn="fadeInRight" animationOut="fadeOutLeft" isVisible={true}>

          <Form className="PassResetReqForm" ref={c => { this.form = c }} onSubmit={this.handleSubmit}>
            <h2 className="formTitle text-center">PLEASE ENTER OTP</h2>

            <OtpField
              required
              id="otp"
              name="otp"
              type="text"
              minLength="6"
              maxLength="6"
              value={this.state.otp}
              className="input__field input__field--madoka"
              validations={[required, numOnly, minChar6, lt]}
              onChange={this.handleInputChange} />

            <div className="form-group submitGroup form-row text-center">
              <Button type="submit" className="btn btn--submit btn-rounded btn-outline-primary mx-auto">SEND</Button>
            </div>
          </Form>
        </Animated>
      </div >
    );
  }
}

export default OTPForm;



// WEBPACK FOOTER //
// ./src/components/OTPForm/OTPForm.js